module.exports = __webpack_public_path__ + "static/media/smart-lighting.a9c4a40b.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/experiences/resources/onboardig/svg/smart-lighting.svg
// module id = 3842
// module chunks = 0